import { type BalanceSheetId, type Dtos, type SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { balanceSheetsQueryKey } from "../../financials";

export function useAdminMarkBalanceSheetReviewed(accountId: SuretyAccountId) {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: (balanceSheetId: BalanceSheetId) =>
			post<Dtos.Admin.BalanceSheet.Get.Response>(
				`/v2/admin/surety/accounts/${accountId}/balance-sheets/${balanceSheetId}/review`,
			),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: balanceSheetsQueryKey(accountId) });
		},
	});

	return {
		reviewBalanceSheet: mutation.mutate,
		reviewBSLoading: mutation.isPending,
		reviewBSError: mutation.error,
		resetReviewBSError: mutation.reset,
	};
}
